import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'gs0017',
    ecrans: ['00-2']
});
